import React from 'react'


class Files extends React.Component {

  


  render() {

    return(

      <div>
        

        <div className="container">

          <h1 style={{textAlign: 'center', margin: '60px 0 20px 0', color: '#816992'}}>{this.props.data.name}</h1><p style={{textAlign: 'center'}}>Click a file to download it.</p>

          <div className="download-wrapper">

            {this.props.data.files.map(file => (
                <a key={file.file} className="list-item-link" href={this.props.data.filePath + file.file} download target="_blank"><div className="list-item">
                    <div style={{margin: 'auto'}}>
                        <img alt="" className="list-item-image" src={this.props.data.fileType} />
                        <h4 className="list-item-title">{file.name}</h4>
                    </div>
                </div></a>
            ))}

          </div>

        </div>

      </div>
    )
  }
}

export default Files



// WEBPACK FOOTER //
// ./src/components/FilesView.js